import { map } from 'rxjs/operators'

import { get, post } from 'utils/rxfetch'

const BASE = (id) => `/members-api/partner/onb_wizard/${id}`

export default function createOnboardingWizardApi() {
  return {
    createTenant(data) {
      return post('/members-api/partner/onb_wizard/', data).pipe(map((r) => r.response))
    },

    fetchStatus(companyId) {
      return get(`${BASE(companyId)}/status/`)
    },

    triggerSync(companyId, data) {
      const { file, ...rest } = data
      if (file) {
        const formData = new FormData()
        formData.append('file', file)
        Object.keys(rest).forEach((k) => {
          if (rest[k] !== undefined) formData.append(k, rest[k])
        })
        return post(`${BASE(companyId)}/sync/`, formData).pipe(map((r) => r.response))
      }
      return post(`${BASE(companyId)}/sync/`, rest).pipe(map((r) => r.response))
    },

    getSettingsOptions(companyId) {
      return get(`${BASE(companyId)}/settings-options/`)
    },

    saveSettings(companyId, data) {
      return post(`${BASE(companyId)}/settings/`, data).pipe(map((r) => r.response))
    },

    enableDmarc(companyId, data) {
      return post(`${BASE(companyId)}/dmarc/`, data).pipe(map((r) => r.response))
    },

    fetchGroups(companyId, refresh = false) {
      const url = `${BASE(companyId)}/groups/${refresh ? '?refresh=true' : ''}`
      return get(url).pipe(
        map((r) => r?.groups || r?.response?.groups || (Array.isArray(r) ? r : []))
      )
    },

    fetchFailedMailboxes(companyId) {
      return get(`${BASE(companyId)}/failed-mailboxes/`).pipe(
        map(
          (r) => r?.failed_mailboxes || r?.response?.failed_mailboxes || (Array.isArray(r) ? r : [])
        )
      )
    },

    createGwsSuperAdmin(companyId, data) {
      return post(`${BASE(companyId)}/gws/super-admin-mailbox/`, data).pipe(map((r) => r.response))
    },

    enableGmailWebhooks(companyId, adminEmail) {
      return post(
        `/members-api/integrations/gmail-webhooks?companyFilter=${companyId}`,
        adminEmail ? { admin_email: adminEmail } : {}
      ).pipe(map((r) => r.response))
    },
  }
}
